<template>
	<div class="pages">
		<section class="classify-table">
			<z-table :offset="params.offset" :count="params.count" :total-count="list.item_total" @handleOffset="handleOffset">
				<th slot="columns" v-for="item in columns">{{item}}</th>
				<tr slot="datasource" v-for="(item, index) in list.list || []">
					<td><z-img-hover :src="item.pic" width="80"></z-img-hover></td>
					<td>{{item.url || '--'}}</td>
					<td>
						<span v-if="item.l_time">{{item.l_time | momentFmt}}</span>
						<span v-else></span>
					</td>
					<td class="operating">
						<router-link  class="operat-btn" tag="a" :to="{ name: 'bannerEdit',query:{id: item.id}}"><i class="icon-edit"></i><span>编辑</span></router-link>
						<el-popover placement="top" width="200" :ref="'popover_'+index">
							<div class="z-popover">
								<div>确定要删除此条数据?</div>
								<div @click="handleClosePopover(index)" class="pop-btns-cont">
									<a class="pop-btn-cancle">取消</a>
									<a @click="handleDelDo(item.id)" class="pop-btn-confirm">确定</a>
								</div>
							</div>
							<a class="operat-btn" slot="reference"><i class="icon-del"></i><span>删除</span></a>
						</el-popover>
					</td>
				</tr>
				<div slot="operate">
					<router-link  class="z-btn z-btn-primary b-r-3" tag="a" :to="{ name: 'bannerEdit'}">新建轮播</router-link>
				</div>
			</z-table>
		</section>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	export default {
		name: 'Classify',
		components: {},
		data() {
			return {
				columns :['图片','链接url', '最后修改时间', '操作'],
				open: false,
				params: {
					offset: 0,//分页偏移量
					count: 10, //每页多少条
				}
			}
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				list: state => state.vmall.bannerList
			})
		},
		mounted() {
			this.handleGetBannerList();
		},
		/*
		 * 事件处理
		 */
		methods: {
			//关闭popover
			handleClosePopover(index) {
				if(typeof(this.$refs['popover_' + index]) != "undefined") this.$refs['popover_' + index][0].doClose();
			},
			//获取轮播列表
			handleGetBannerList() {
				this.getBannerList(this.params)
			},
			
			//处理分页
			handleOffset(offset) {
				this.params.offset = offset;
				this.handleGetBannerList();
			},
			//删除轮播
			handleDelDo(id) {
				this.deleteBanner({id}).then((data)=>{
					this.$success('删除成功');
					this.handleGetBannerList();
				},(msg)=>{
					this.$errorMsg(msg)
				})
			},
			
			...mapActions(['getBannerList', 'deleteBanner']),
		},
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	@media only screen and (min-width:0px) and (max-width:640px) {
		.pages{
			min-width: px-em(1400px);
		}
	}
</style>


// WEBPACK FOOTER //
// Banner.vue?2aed692a